export function useCameraMicStatus() {
  const cameraStatus = reactive({});
  const micStatus = reactive({});
  function changeDeviceStatus({
    rtilCode,
    type,
    val
  }) {
    type === 'camera' ? cameraStatus[rtilCode] = val : micStatus[rtilCode] = val;
  }
  return {
    cameraStatus,
    micStatus
  };
}